import ROUTES from '../../../AppRoutes/RouteConstants';
import { sections } from '../constants/sectionConstants';
import get from 'lodash/get';
import getGeneric from '../../../actions/getGeneric';
import preProcessOptions from './preProcessOptions';

export const getSectionFromPath = pathname => {
  if (pathname.endsWith(ROUTES.OVERVIEW)) return sections.OVERVIEW;
  if (pathname.endsWith(ROUTES.ONLINE_REVIEW)) return sections.ONLINE_REVIEW;
  if (pathname.endsWith(ROUTES.FEEDBACK)) return sections.FEEDBACK;
  if (pathname.endsWith(ROUTES.ALERTS)) return sections.ALERTS;
  if (pathname.endsWith(ROUTES.AI_INSIGHTS)) return sections.AI_INSIGHTS;
  return 'default';
};

export const reconcileFiltersWithOptions = (prev, config) => {
  let changed = false;
  const next = { ...prev };

  config.forEach(filter => {
    const key = filter.key;
    const selected = prev[key];
    const options = filter.options || [];

    if (!selected?.length) return;

    const valid = new Set(options.map(o => JSON.stringify(o.fullValue)));
    const validSelected = selected.filter(s => valid.has(JSON.stringify(s.fullValue)));

    if (validSelected.length !== selected.length) {
      changed = true;
      validSelected.length ? (next[key] = validSelected) : delete next[key];
    }
  });

  return changed ? next : prev;
};

export const fetchDynamicFilters = ({
  dispatch,
  dynamicFilterParams,
  currentTimePeriod,
  currentPropertyId,
  allSectionsConfig,
  onComplete,
  batchConfig = { batchSizeMonths: 6 }
}) => {
  const { start_date, end_date } = currentTimePeriod?.[0] || {};

  dispatch({
    type: 'SET_DYNAMIC_FILTER_VALUES_LOADING',
    payload: { loading: true }
  });

  if (!start_date || !end_date) {
    dispatch({
      type: 'SET_DYNAMIC_FILTER_VALUES_LOADING',
      payload: { loading: false }
    });
    return;
  }

  const batches = splitIntoMonthBatches(start_date, end_date, batchConfig);

  const promises = batches.map(
    batch =>
      new Promise(resolve => {
        dispatch(
          getGeneric({
            requestBody: {
              data_tag: 'DATATAG_DELIGHTIQ_CST_FILTERS',
              request_data: {
                ...dynamicFilterParams,
                filters: {
                  ...batch,
                  additional_filters: { property_id: currentPropertyId }
                }
              }
            },
            onSuccess: e => {
              resolve(get(e, 'api_response.METHODTAG_DELIGHTIQ_PARSE_TO_FILTER_VALUES.data', {}));
            },
            onError: () => resolve({})
          })
        );
      })
  );

  Promise.all(promises).then(results => {
    const merged = results.reduce((acc, curr) => {
      Object.keys(curr).forEach(key => {
        acc[key] = preProcessOptions([...(acc[key] || []), ...(curr[key] || [])]);
      });
      return acc;
    }, {});

    onComplete(merged, allSectionsConfig);
  });
};

export const isSameValue = (a, b) => JSON.stringify(a ?? []) === JSON.stringify(b ?? []);

export const splitIntoMonthBatches = (start_date, end_date, config) => {
  const { batchSizeMonths } = config;

  const start = new Date(start_date);
  const end = new Date(end_date);
  const batches = [];

  let currentStart = new Date(start);

  while (currentStart < end) {
    let currentEnd = new Date(currentStart);

    currentEnd.setMonth(currentEnd.getMonth() + batchSizeMonths);

    if (currentEnd > end) {
      currentEnd = new Date(end);
    }

    batches.push({
      start_date: currentStart.toISOString().slice(0, 10),
      end_date: currentEnd.toISOString().slice(0, 10)
    });

    currentStart = currentEnd;
  }

  return batches;
};
